
import { CaseStudy } from "@/types/expertise";
import AnimatedCard from "../AnimatedCard";
import CardSection from "./CardSection";
import ResultsList from "./ResultsList";
import SourceCitation from "./SourceCitation";
import { Badge } from "@/components/ui/badge";

interface CaseStudyCardProps {
  study: CaseStudy;
  index: number;
}

const CaseStudyCard = ({ study, index }: CaseStudyCardProps) => {
  return (
    <AnimatedCard 
      delay={index * 150} 
      animation="fade-in"
      className="h-full"
    >
      <div className="backdrop-blur-lg bg-white/5 border border-white/10 rounded-2xl overflow-hidden h-full flex flex-col">
        {/* Image at the top of the card if available */}
        {study.image && (
          <div className="w-full h-48 overflow-hidden">
            <img 
              src={study.image} 
              alt={`${study.title} illustration`}
              className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
            />
          </div>
        )}
        
        <div className="p-6 flex flex-col flex-grow">
          <div className="mb-4">
            <Badge 
              variant="default" 
              className="bg-white text-primary font-medium px-3 py-1.5 shadow-sm border border-white/20"
            >
              {study.client}
            </Badge>
          </div>
          <h3 className="text-xl font-semibold mb-4">{study.title}</h3>
          
          <CardSection title="Challenge:" className="mb-4">
            <p className="text-white/80 text-sm">{study.challenge}</p>
          </CardSection>
          
          <CardSection title="Solution:" className="mb-4">
            <p className="text-white/80 text-sm">{study.solution}</p>
          </CardSection>
          
          <CardSection title="Results:" className="mb-4">
            <ResultsList results={study.results} />
          </CardSection>
          
          {study.source && (
            <SourceCitation text={study.source.text} url={study.source.url} />
          )}
        </div>
      </div>
    </AnimatedCard>
  );
};

export default CaseStudyCard;
